import { PaymentMethodType } from '@hooks-api/types/dataModel/payment'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { type ReactNode } from 'react'
import { Trans } from 'react-i18next'

export const useClientPaymentMethod = () => {
  const paymentMethod: Partial<Record<PaymentMethodType, ReactNode>> = {
    [PaymentMethodType.CREDIT_CARD_ONCE]: '信用卡 一次付清',
    [PaymentMethodType.CREDIT_CARD_INSTALLMENT]: '信用卡 分期付款',
    [PaymentMethodType.CASH_ON_DELIVERY]: '貨到付款',
    [PaymentMethodType.CVS]: '超商代碼繳費',
    [PaymentMethodType.ATM]: 'ATM 轉帳',
    [PaymentMethodType.ASSIGNED_PAYMENT]: '指定付款',
    [PaymentMethodType.ASSIGNED_PAYMENT_INVOICE]: '指定付款（開發票）',
    [PaymentMethodType.APPLE_PAY]: 'Apple Pay',
    [PaymentMethodType.LINE_PAY]: 'LINE Pay',
    [PaymentMethodType.JKO_PAY]: 'JKO Pay',
    [PaymentMethodType.ALIPAY_HK]: 'AliPayHK',
    [PaymentMethodType.OFFLINE_PAYMENT]: <HStack alignItems="end"><Trans i18nKey="paymentMethod.offline_payment" components={{ note: (<Text variant="body" lineHeight="28px" bold color="red" />) }} /></HStack>,
  }

  const getI18nPaymentMethod = (payment: PaymentMethodType) => {
    return paymentMethod[payment] || ''
  }
  return { getI18nPaymentMethod }
}
